// This file is automatically generated. Do not edit manually.

import { CatalogPartView } from "src/api/generated/erp/db/types/tables/catalogPartView";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace CatalogPartApi {
	export async function getCatalogPartOptions(args: {
		searchQuery?: string;
		currentSelection: number | null | undefined;
		onlyIfConfigurable?: boolean;
		configurationProductFamilyId?: number | null | undefined;
	}): Promise<Array<CatalogPartView>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/productManagement/catalogPart/getCatalogPartOptions",
			method: "POST",
			data: {
				searchQuery: args.searchQuery,
				currentSelection: args.currentSelection,
				onlyIfConfigurable: args.onlyIfConfigurable,
				configurationProductFamilyId: args.configurationProductFamilyId,
			},
		});
		return response as Array<CatalogPartView>;
	}

	export async function getCatalogPartById(args: { catalogPartId: number }): Promise<CatalogPartView> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/productManagement/catalogPart/getCatalogPartById",
			method: "POST",
			data: {
				catalogPartId: args.catalogPartId,
			},
		});
		return response as CatalogPartView;
	}
}
